import { z } from "zod";

// Form validation schema for creating a dashboard
export const createDashboardFormSchema = z.object({
  title: z.string().min(1, "Title is required").max(100, "Title must be less than 100 characters"),
  description: z.string().max(500, "Description must be less than 500 characters").optional(),
  isDefault: z.boolean().optional().default(false),
});

export type CreateDashboardFormValues = z.infer<typeof createDashboardFormSchema>;

// Dashboard filter search params schema
export const dashboardSearchSchema = z.object({
  startDate: z.string().optional(),
  endDate: z.string().optional(),
});

export type DashboardSearchParams = z.infer<typeof dashboardSearchSchema>;
